import merge from "lodash.merge";

const defaultIntegrationConfig = {
        name: 'Default',
        addOns: {
          adoptionFlag: {}
        },
        base: {
          debug: true,
          addOns: () => window._fitAnalytics.addOns,
          shop: {
            prefix: 'fjallraven',
            country: {
              selector: 'meta[name="country"]',
              attr: 'content'
            },
            language: {
              selector: 'meta[name="language"]',
              attr: 'content'
            },
            userId: {
              selector: 'meta[name="user-id"]',
              attr: 'content'
            }
          },

          scope: '.testCase',
          product: {
            container: '.row',

            hasManufacturedSizes: true,

            colorSeparator: '-',
            styleId: {
              selector: 'meta[name="style-id"]',
              attr: 'content'
            },

            currentColorId: {
              selector: '.colors .colorId.selected',
              attr: 'value'
            },

            colorIds: {
              selector: '.colors .colorId',
              attr: 'value'
            },

            thumbnail: {
              selector: '.img-thumbnail',
              attr: 'src'
            },

            addToCart: 'button.add-to-cart',

            sizes: {
              items: '.sizes button',
              code: {
                selector: '.',
                prop: 'value'
              },
              isAvailable: {
                selector: '.',
                is: ':not([disabled])'
              },
              isSelected: {
                selector: '.',
                is: '.selected'
              },
              shouldSelectRecommended: true
            }
          },

          button: {
            anchor: '.sizes',
            anchorPlacement: 'after'
          },

          sizeChartButton: {
            elem: '.size-chart-button',
            shouldHide: true
          }
        }
      },

      adoptionFlagWithShowHideDelay = merge({}, defaultIntegrationConfig, {
        name: 'AF Show/Hide Delay',
        addOns: {
          adoptionFlag: {
            showBehavior: {
		          delay: 3 // Expressed on seconds
            },
            hideBehavior: {
	            autoHideDelay: 3 // Expressed on seconds
            }
          }
        }
      }),
      adoptionFlagWithShowDelay = merge({}, defaultIntegrationConfig, {
        name: 'AF Show Delay',
        addOns: {
          adoptionFlag: {
            showBehavior: {
		          delay: 3 // Expressed on seconds
            }
          }
        }
      }),
      adoptionFlagWithHideDelay = merge({}, defaultIntegrationConfig, {
        name: 'AF Hide Delay',
        addOns: {
          adoptionFlag: {
            hideBehavior: {
	            autoHideDelay: 3 // Expressed on seconds
            }
          }
        }
      }),
      adoptionFlagWithShowHideTransition = merge({}, defaultIntegrationConfig, {
        name: 'AF Show/Hide Transition',
        addOns: {
          adoptionFlag: {
            showBehavior: {
              delay: 1,
              transition: 'fade-in'
            },
            hideBehavior: {
              autoHideDelay: 3,
              transition: 'fade-out'
            }
          }
        }
      }),
      adoptionFlagShowHideOnHover = merge({}, defaultIntegrationConfig, {
        name: 'AF show/hide onHover',
        addOns: {
          adoptionFlag: {
            showBehavior: {
              whenHoverOver: '.size-button'
            },
            hideBehavior: {
              whenHoverOver: '.product .img-thumbnail'
            }
          }
        }
      }),
      adoptionFlagShowHideOnMouseLeave = merge({}, defaultIntegrationConfig, {
        name: 'AF show/hide onMouseLeave',
        addOns: {
          adoptionFlag: {
            showBehavior: {
              whenMouseLeaves: '.size-button'
            },
            hideBehavior: {
	            whenMouseLeaves: '.colorId'
            }
          }
        }
      }),
      adoptionFlagShowHideOnViewPort = merge({}, defaultIntegrationConfig, {
        name: 'AF show/hide onViewPort',
        addOns: {
          adoptionFlag: {
            showBehavior: {
              whenInViewport: true,
              transition: 'fade-in'
            },
            hideBehavior: {
              whenInViewport: true,
              transition: 'fade-out'
            }
          }
        }
      }),
      adoptionFlagShowHideOnClick = merge({}, defaultIntegrationConfig, {
        name: 'AF show/hide onClick',
        addOns: {
          adoptionFlag: {
            showBehavior: {
              whenClick: '.size-button',
              transition: 'fade-in'
            },
            hideBehavior: {
              whenClick: '.colorId',
              transition: 'fade-out'
            }
          }
        }
      }),

      integrationConfigs = [ defaultIntegrationConfig, adoptionFlagWithShowHideDelay, adoptionFlagWithShowDelay, adoptionFlagWithHideDelay, adoptionFlagWithShowHideTransition, adoptionFlagShowHideOnHover, adoptionFlagShowHideOnMouseLeave, adoptionFlagShowHideOnViewPort, adoptionFlagShowHideOnClick ];

export { integrationConfigs, defaultIntegrationConfig };
